import { Box, Button, Divider, Grid2, Stack, Typography } from "@mui/material"
import React, { Fragment, useState } from "react"
import { useTranslation } from "react-i18next"
import { IJobListQueryOutput } from "../../entities/job/interface"

const DetailRow: React.FC<{ label: string; value: string }> = ({ label, value }) => {
    return (
        <Fragment>
            <Grid2 size={3}>
                <Typography align="right" variant="body2">
                    {label}:
                </Typography>
            </Grid2>
            <Grid2 size={9}>
                <Typography variant="body2" color="text.secondary">
                    {value}
                </Typography>
            </Grid2>
        </Fragment>
    )
}
export const DetailSection: React.FC<{ sectionIndex: number; job: IJobListQueryOutput }> = ({ sectionIndex, job }) => {
    const { t } = useTranslation()
    if (sectionIndex === 0) {
        // currently no comments in the job object
        // return <Typography variant="body2">{job.comments || t("jobs.mobile.noComments")}</Typography>
        return <Typography variant="body2">{t("jobs.mobile.noComments")}</Typography>
    } else if (sectionIndex === 1) {
        return (
            <Box>
                <Grid2 container spacing={1}>
                    <DetailRow label={t("jobs.mobile.jobInfo.jobId")} value={job._id} />
                    <DetailRow label={t("jobs.mobile.jobInfo.jobRef")} value={job.jobReference} />
                    <DetailRow label={t("jobs.mobile.jobInfo.client")} value={job.billable.company} />
                </Grid2>
            </Box>
        )
    } else {
        return null
    }
}

export const JobDetail: React.FC<{ job: IJobListQueryOutput }> = ({ job }) => {
    const [sectionIndex, setShowSectionIndex] = useState<number>(0)
    const { t } = useTranslation()

    return (
        <Box
            display={"flex"}
            flexDirection={"column"}
            marginLeft={2}
            marginBottom={2}
            width="88%"
            alignItems={"center"}
        >
            <Divider
                sx={{
                    width: "100%",
                    marginBottom: 2,
                    borderColor: "white",
                }}
            />
            <Box justifyContent={"center"}>
                <Stack spacing={2} direction="row">
                    <Button
                        size="small"
                        variant="contained"
                        color="secondary"
                        onClick={(event) => setShowSectionIndex(0)}
                    >
                        {t("jobs.mobile.buttons.comments")}
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        color="secondary"
                        onClick={(event) => setShowSectionIndex(1)}
                    >
                        {t("jobs.mobile.buttons.jobInfo")}
                    </Button>
                </Stack>
            </Box>
            <Box sx={{ marginTop: 1, paddingLeft: 2, paddingRight: 2, width: "100%" }}>
                <DetailSection sectionIndex={sectionIndex} job={job} />
            </Box>
        </Box>
    )
}
